import CommonAdapter from '../../adapters/CommonAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';
import { GetRemoveInternetHeadersArgs } from './InternetHeadersArgs';
import { isValidInternetHeaderKeysArray } from './internetHeaderValidationUtils';

export default async function getInternetHeadersAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: GetRemoveInternetHeadersArgs,
    callback: ApiMethodCallback
) {
    if (!data || !isValidInternetHeaderKeysArray(data.internetHeaderKeys)) {
        callback(createErrorResult());
        return;
    }
    const adapter: CommonAdapter = getAdapter(hostItemIndex) as CommonAdapter;
    const dictionary = await adapter.getInternetHeaders(data.internetHeaderKeys);
    callback(createSuccessResult(dictionary));
}
